<template>
  <public-layout>
    <section class="hero hero-header-1">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">
                Kindergarten
              </p>
              <p class="product-subtitle">
                Enabling you to take your classroom to the next level!
              </p>
              <p class="product-description">
                Fun Academy Kindergarten is a comprehensive educational package based on the Fun Learning approach. Features a unique teacher’s manual, professional development for teachers and inspiring learning environment design guidelines.
                 Gives full access to additional material and tools to make learning FUN!
              </p>
              <p class="product-cta">
                <a href="javascript:;" @click="moreInfo = !moreInfo" class="button button-large button-secondary">{{moreInfo?'Read Less':'Read More'}}</a>
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/kinder.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="hero is-light section-description" v-if="moreInfo">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered has-text-centered">
            <div class="column">
              <p class="subsection-title">
                “If children have interest, education happens.”<strong> Sir Arthur C. Clarke</strong>
              </p>
              <p class="subsection-subtitle">
                Fun Academy Kindergarten develops Life Skills and STEAM (Science, Technology, Engineering, Arts and Math) in young children.
                 Facilitates collaborative learning through play and exploration. Fosters active participation and nurtures a passion for learning from an early age.
              </p>
            </div>
          </div>

          <section-bullets :items="readMoreItems"></section-bullets>
        </div>
      </div>
    </section>

    <section class="hero section-services" :class="{ 'has-top-gray-hero': !moreInfo }">
      <div class="hero-body">
        <div class="container">
          <div class="columns has-text-centered">
            <div class="column">
              <p class="subsection-title">
                <strong>Kindergarten Solutions</strong>
              </p>
            </div>
          </div>

          <div class="columns" v-for="(solution, index) in solutions" :key="index">
            <div class="column is-two-thirds" :class="{ 'is-offset-one-third': index % 2 !== 0 }">
                <product-card :data="solution" :isReverse="index % 2 !== 0"></product-card>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="hero is-light section-testimonies">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered has-text-centered">
            <div class="column">
              <p>
                “We decided to implement the Fun Learning approach in our school since it reflects our personality.
                 We started with the process of teacher training, now we have provided new teaching resources for the classes and created inspiring learning environments,
                  compatible with games and exploration.”
              </p>
              <small>Liceo Europeo<br><i>Madrid, Spain.</i></small>
            </div>
          </div>
        </div>
      </div>
    </section>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import SectionBullets from '@/components/SectionBullets'
import SectionContact from '@/components/SectionContact'
import ProductCard from '@/components/ProductCard'
import Button from '@/components/Button'

export default {
  name: 'kinderpage',

  components: {
    PublicLayout,
    SectionBullets,
    SectionContact,
    ProductCard,
    Button
  },

  created () {},

  data () {
    return {
      moreInfo: false,
      readMoreItems: [
        `<strong>Rooted in world-renowned Finnish education expertise,</strong> and combined with best practices around the world.`,
        `<strong>Adapts to fit</strong> the learning strategies of each child, local culture and curricular goals.`,
        `<strong>Develops key life skills</strong> to tackle real-world challenges through project-based learning.`,
        `<strong>Evolves constantly</strong> by adapting to the latest educational and technological advances.`
      ],
      solutions: [
        {
          title: `Teacher's Manual`,
          description: 'Features 1,440 easy-to-implement lessons, covering four consecutive curricular years of early education. Combines educational content and curricular goals following a universal, thematic and play-based approach to learning. Enables teachers to promote essential physical, social and emotional skills in their classroom.',
          img: 'static/img/assets/kinder-1.png',
          to: { name: 'manual' }
        },
        {
          title: `Professional Development`,
          description: 'Offers onsite and online early years teacher training in Fun Learning. Supports each teacher’s pedagogy through a holistic learning philosophy. Enables educators to support the overall wellbeing of young children and make learning FUN!',
          img: '/static/img/assets/home-5.png',
          to: { name: 'prof-dev' }
        },
        {
          title: `Fun Learning Classroom`,
          description: 'Facilitates the creation of safe and inspiring learning environments. Pedagogically designed to support diverse learning strategies and an effective kindergarten experiences. Embodies a positive and respectful atmosphere where children can grow and evolve organically.',
          img: 'static/img/assets/kinder-3.png',
          to: { name: 'classroom' }
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.subsection-subtitle{
    color: #6B7285;
    font-size: 1rem;
    margin-top: 1.6rem;
}

.section-testimonies{
  p{
    color: #6B7285;
    font-style: italic;
    font-size: 1.625rem;
    line-height: 1.55;
  }
  small{
    display: block;
    font-size: 1rem;
    padding-top: 1rem;
    i{
      color: #6B7285;
    }
  }
}

.section-cta{
  .hero-body{
    padding-bottom: 0;
  }

  .image-wrapper{
    overflow:hidden;
    height: 400px;
  }
}

// .more-info{
//   height: 0;
//   &.is-active{
//     height: 300px;
//     transition: height 2s;
//   }
// }

</style>



// WEBPACK FOOTER //
// src/pages/KinderPage.vue